import React, { Component } from 'react';
import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';


import DetailsPanel2 from '../../../../_components/common/TableNew/details2'
import TableNew from '../../../../_components/common/TableNew'
import CustomTableNew from '../../../../_components/common/CustomTableNew'
import { tables } from './tableColumns';
import { sellerActions, sellerAdminActions, countryListActions, creditListActions, editSellerActions, AddSellerAdminAction, organisationListActions, getRelationList, orgEditRelationAction, BulkDownloadActions } from '../../../../_actions';
import { creditOrgActions } from '../../../../_actions/organisations/orgcredits.action';
import { adminOrgActions } from '../../../../_actions/organisations/orgAdminList.action';

import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action'
import { organisationAction } from '../../../../_actions/organisation.action';
import { connect } from 'react-redux';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import ModalNew from '../../../../_components/common/ModalNew';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';




import Swal from 'sweetalert2'

import { compareBy } from '../component/CompareFunc';
import { organisationConstants } from '../../../../_constants/organisation.constants';



import { formData, editOrgDetails, addAdminOrg, BatchPermission } from '../formData';

//settings tab
import SettingsHead from '../../../../_components/common/SettingsHead';
import { organisation } from '../../../../_reducers/organisation.reducer';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../../_components/common/Form2/index.css';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../../404page';


import downloadCsv from 'download-csv';


class OrgDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {



            creditTableRowId: 0,

            modal: false,
            editOrgModal: false,
            delModal: false,
            orgAdmin: false,
            orgId: 0,
            sellerId: 0,
            organisationCreditTable: '',
            sortTypeCredit: false,
            organisationAdminTable: '',
            sortTypeAdmin: false,
            sellerObj: {},
            getImpId: false,
            locationId: 0,
            orgObj: {},
            loaderDetails: "https://cdn.dribbble.com/users/421466/screenshots/2379575/replace-2r-400px.gif",
            primaryChangeSuccess: false,
            creditsData: '',
            batchPermissionModal: false,
            orgAdminRow: {},
            checkBoxArr: [],
            sellCredits: false,
            sellEachCredits: false,
            revokeCredits: false,
            creditIntrumentId: 0,
            editRelationState: false,
            addRelation: [],
            availableCredits: 0,


            loadedAllData: false,

            externalLinksState: [],

            downloadCsvData: {},

            buttonDataState: [],


            hasProperOrgId: true,
            idLoader: true,
        }
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }

    toggleEditOrgModal(showModal) {
        this.setState({
            editOrgModal: showModal
        });
    }

    toggleDelOrgModal(showModal) {
        this.setState({
            delModal: showModal
        })
    }

    toggleEditOrg(showModal) {
        this.setState({
            editOrgModal: showModal
        })
    }

    toggleAdminOrgModal(showModal) {
        this.setState({
            orgAdmin: showModal
        })
    }

    managePrimaryAdmin(key, data) {
        const { dispatch } = this.props;

        if (key.key === 'user_access__is_primary_admin') {
            Swal({
                title: `Are you sure you want to Make ${data.full_name} as a Primary Admin?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.value) {
                    let sellerIdLocal = localStorage.getItem('seller_id')
                    dispatch(
                        organisationAction.makePrimaryAdmin({
                            "seller_id": this.state.sellerId,
                            "org_id": this.state.locationId,
                            "email": data.email
                        })
                    )
                    let toastId1 = toast['info'](`New Primary Admin is ${data.full_name}!`, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        autoClose: 1500,
                    });

                    toast.update(toastId1, {
                        render: `New Primary Admin is ${data.full_name}!`,
                        type: toast.TYPE.INFO,
                        className: 'styleToastSuccess'
                    })
                }
            })
        } else if (key.key === 'bulk_download_permission_given') {
            Swal({
                title: `Are you sure you want to ${data.bulk_download_permission_given ? 'Deny' : 'Allow'} ${data.full_name} to Download Bulk Report?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.value) {
                    if (data.bulk_download_permission_given) {
                        dispatch(BulkDownloadActions.removeBulkDownloadPermissions(
                            { "organisation_id": this.state.orgId, "org_admin_ids": [data.id] },
                            (error, response) => {
                                if (error) {
                                    // Show error message in SweetAlert
                                    Swal('Error', error.response.data.message, 'error');
                                } else {
                                    // Show success message in SweetAlert
                                    Swal('Success', response.data.message, 'success');
                                    // Dispatch the action here, after the "Yes" button is clicked
                                    dispatch(adminOrgActions.getAdminList(this.state.sellerId, this.state.orgId));
                                }
                            }
                        ));
                    } else {
                        dispatch(BulkDownloadActions.addBulkDownloadPermissions(
                            { "organisation_id": this.state.orgId, "org_admin_ids": [data.id] },
                            (error, response) => {
                                if (error) {
                                    // Show error message in SweetAlert
                                    Swal('Error', error.response.data.message, 'error');
                                } else {
                                    // Show success message in SweetAlert
                                    Swal('Success', response.data.message, 'success');
                                    // Dispatch the action here, after the "Yes" button is clicked
                                    dispatch(adminOrgActions.getAdminList(this.state.sellerId, this.state.orgId));
                                }
                            }
                        ));
                    }
                }
            });
        } else if (key.key === '') {

            let checkBoxArr = []

            this.props.batchList !== '' &&
                this.props.batchList.map(val => {
                    let checkboxObj = {
                        key: val.batch_name,
                        type: 'checkbox',
                        value: false,
                        valid: true,
                        elementConfig: {
                            name: 'batch_code',
                            label: val.batch_name,
                        },
                        validation: {
                            required: false,
                            message: ""
                        },
                    }
                    checkBoxArr.push(checkboxObj)
                })

            data.batch_permission.map(value => {
                checkBoxArr.map(val => {
                    if (value.batch__batch_name === val.key) {

                        val.value = true
                    }
                })
            })

            this.setState({
                orgAdminRow: data,
                checkBoxArr
            }, () => {
                this.togglebatchPermissionModal(true)
            })
        }
    }

    delAdmin(key, data) {
        const { dispatch } = this.props;

        Swal({
            title: `Are you sure you want to remove ${data.full_name} as admin?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, remove it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                dispatch(
                    organisationAction.removeOrgAdmin({
                        seller_id: this.state.sellerId,
                        org_id: this.state.orgId,
                        data: {
                            email: data.email
                        }
                    })
                )

                let toastId2 = toast['info'](`removed ${data.full_name} from Admin list!`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastId2, {
                    render: `removed ${data.full_name} from Admin list!`,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            }
        })

    }

    deleteAdmin(key, data) {
        const { dispatch } = this.props;

        Swal({
            title: `Are you sure you want to delete ${data.full_name} ?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                dispatch(
                    organisationAction.deleteOrgAdmin({
                        seller_id: this.state.sellerId,
                        org_id: this.state.orgId,
                        data: {
                            email: data.email
                        }
                    })
                )

                let toastId2 = toast['info'](`Deleted ${data.full_name}!`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastId2, {
                    render: `Deleted ${data.full_name} !`,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            }
        })
    }




    editOrgAction(data) {
        const { dispatch } = this.props;


        let organisationCode = '';
        this.props.organisationList.map(val => {
            if (val.id === this.state.orgId) {
                organisationCode = val.organisation_code
            }
        })

        let constructData = Object.assign({}, data)

        constructData['organisation_code'] = organisationCode

        if (constructData.pincode === '') {
            constructData.pincode = null
        } else if (constructData.pincode !== '') {
            constructData.pincode = parseInt(constructData.pincode, 10)
        }

        if (constructData.country === '') {
            constructData.country = null
        }
        dispatch(organisationAction.editOrganisation({
            constructData,
            id: this.state.sellerId,
            orgId: this.state.orgId
        }))
    }

    delOrgAction(ok) {
        const { dispatch } = this.props;

        const objectDel = {
            "organisation_id": this.state.orgId
        }

        dispatch(organisationAction.deleteOrganisation(objectDel));
    }

    addOrgAdmin(data) {
        let sellerId = localStorage.getItem('seller_id')
        const objectAdmin = {
            "seller_id":  this.state.sellerId,
            "oganisation_id": this.state.locationId,
            "email": data.email,
            "full_name": data.full_name,
            "short_name": data.short_name
        }


        const { dispatch } = this.props;

        dispatch(organisationAction.addOrganisationAdmin(objectAdmin))
    }

    batchPermAdminAction(data) {
        const { dispatch } = this.props;
        let dataArr = [];

        for (const key in data.sellerData) {
            if (data.sellerData.hasOwnProperty(key)) {
                const element = data.sellerData[key];
                if (element === true) {
                    dataArr.push(key)
                }
            }
        }



        let properDataArr = []
        this.props.batchList.map(val => {
            dataArr.map(value => {
                val.batch_name === value &&
                    properDataArr.push(val)
            })
        })



        let batchIdArr = []

        properDataArr.map(val => {
            batchIdArr.push(val.id)
        })

        let dataObj = {
            "user_id": this.state.orgAdminRow.id,
            "batch_ids": batchIdArr
        }

        dispatch(organisationAction.batchPermissionAction({
            orgId: this.state.orgId,
            sellerId: this.state.sellerId,
            data: dataObj
        }, (batch_perm_response) => {
            Swal({
                title: batch_perm_response.data.message,
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK',
            })
        }))
    }

    sortBy(columnKey, type, tableName) {

        if (tableName === 'organisationCreditTable') {
            this.setState({ sortTypeCredit: type })
            const arrayCopy = this.state.organisationCreditTable === '' ? this.props.credits : this.state.organisationCreditTable;
            arrayCopy.sort(compareBy(columnKey, this.state.sortTypeCredit));
            this.setState({ organisationCreditTable: arrayCopy })

        } else if (tableName === 'organisationAdminTable') {
            this.setState({ sortTypeAdmin: type })
            const arrayCopy2 = this.state.organisationAdminTable === '' ? this.props.admins : this.state.organisationAdminTable;
            arrayCopy2.sort(compareBy(columnKey, this.state.sortTypeAdmin));
            this.setState({ organisationAdminTable: arrayCopy2 })

        }


    }

    componentDidUpdate(prevProps) {

        if (prevProps.delOrgLoading !== this.props.delOrgLoading) {
            if (!this.props.delOrgLoading && !this.props.delOrgError) {
                let toastId3 = toast['info'](`Organisation ${this.props.delOrgMessage.deleted.data.message}`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastId3, {
                    render: `Organisation ${this.props.delOrgMessage.deleted.data.message}`,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            }
        }
        if (prevProps.credits !== this.props.credits) {
            if (this.props.credits !== '') {
                this.props.credits.map(val => {
                    val['total'] = val.sold_credits + val.unsold_credits
                })

                this.setState({
                    creditsData: this.props.credits
                })
            }
        }
        if (prevProps.organisationList !== this.props.organisationList) {
            if (this.props.organisationList !== '') {
                if (this.props.organisationList.length !== 0) {
                    let sellerIdLocal = localStorage.getItem('seller_id')
                    const { organisationList, dispatch } = this.props
                    let hasId = false
                    if (sellerIdLocal !== 'null') {
                        for (let i = 0; i < organisationList.length; i++) {
                            const element = organisationList[i];

                            if (element.id == this.state.locationId) {
                                hasId = true

                                dispatch(creditOrgActions.getOrgCredit(element.seller__id, this.state.locationId))
                                dispatch(adminOrgActions.getAdminList(element.seller__id, this.state.locationId))
                                dispatch(organisationAction.setIds({
                                    orgId: this.state.locationId,
                                    sellerId: element.seller__id
                                }))
                                dispatch(manageBatchActions.getBatchList({
                                    orgId: this.state.locationId,
                                    sellerId: element.seller__id
                                }));
                            }
                        }

                        this.setState({
                            hasProperOrgId: hasId,
                            idLoader: false,
                        })

                    } else {
                        for (let i = 0; i < organisationList.length; i++) {
                            const element = organisationList[i];

                            if (element.id == this.state.locationId) {
                                hasId = true
                            }
                        }
                        this.setState({
                            hasProperOrgId: hasId,
                            idLoader: false,
                        })
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const role = localStorage.getItem('usertype');
        // const orgId = localStorage.getItem('orgId');
        const is_primary_admin = localStorage.getItem('is_primary_admin');

        dispatch(sellerActions.getSellers());
        this.props.dispatch(getRelationList.getRelationListHandler());



        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");

        dispatch(organisationAction.getIntrumentList());
        dispatch(organisationAction.getOrganisation(() => { }));
        dispatch(countryListActions.getCountries());
        let sellerIdLocal = localStorage.getItem('seller_id')

        let buttonDataState = [
            {
                id: 1,
                heading: "Edit Organisation",
                state: this.state.editOrgModal,
                toggler: this.toggleEditOrgModal.bind(this),
            },

            {
                id: 3,
                heading: "Edit Relation",
                state: this.state.editRelationState,
                toggler: this.toggleRelationModal.bind(this)
            }
        ]

        this.setState({
            buttonDataState,
            locationId: orgIdFromPath,
            orgId: orgIdFromPath,
            externalLinksState: [
                {
                    id: 1,
                    heading: "MANAGE BATCHES",
                    link: "manageBatches",
                },
                {
                    id: 2,
                    heading: "MANAGE PARTICIPANTS",
                    link: "manageParticipants"
                },
                {
                    id: 3,
                    heading: "MANAGE METRICS",
                    link: "manageMetrics"
                },
                {
                    id: 4,
                    heading: 'UPLOAD ASSESSMENT',
                    link: 'uploadAssessment'
                },
                {
                    id: 5,
                    heading: 'UPLOAD RESPONDENTS',
                    link: 'uploadRespondent'
                },
                {
                    id: 6,
                    heading: 'GROUP REPORT',
                    link: 'groupReport'
                },
                {
                    id: 7,
                    heading: 'MANAGE ROLES',
                    link: 'manage-roles'
                },
                {
                    id: 8,
                    heading: 'UPLOAD ASSESSMENT RESPONSES',
                    link: 'uploadAssessmentResponse'
                },
            ]
        }, () => {
            if (sellerIdLocal !== 'null') {
                this.setState({
                    sellerId: sellerIdLocal,
                    externalLinksState: [
                        {
                            id: 1,
                            heading: "MANAGE BATCHES",
                            link: "manageBatches",
                        },
                        {
                            id: 2,
                            heading: "MANAGE PARTICIPANTS",
                            link: "manageParticipants"
                        },
                        {
                            id: 3,
                            heading: "MANAGE METRICS",
                            link: "manageMetrics"
                        },
                        {
                            id: 4,
                            heading: 'BULK UPLOAD',
                            link: 'uploadAssessment'
                        },
                        {
                            id: 5,
                            heading: 'UPLOAD RESPONDENTS',
                            link: 'uploadRespondent'
                        },
                        {
                            id: 6,
                            heading: 'MANAGE ROLES',
                            link: 'manage-roles'
                        },
                        {
                            id: 7,
                            heading: 'UPLOAD ASSESSMENT RESPONSES',
                            link: 'uploadAssessmentResponse'
                        },
                    ]
                })
            }
        })

    }


    getSellerOrgId(seller) {
        const { dispatch } = this.props;
        const { locationId } = this.state;
        const { organisationList } = this.props;

        let organisationId = parseInt(locationId, 10)

        seller !== '' &&
            organisationList !== '' &&
            this.mapOrgList({
                organisationList,
                seller,
                locationId: organisationId,
                dispatch
            })

    }

    mapOrgList(objectData) {
        const { organisationList, locationId, seller, dispatch } = objectData

        organisationList.map(val => {
            if (locationId == val.id) {
                return this.mapSellerList({
                    seller,
                    val,
                    dispatch,
                    locationId
                })
            }
        })
    }

    mapSellerList(objectData) {
        const { seller, val, dispatch, locationId } = objectData
        let count = 0
        seller.map(data => {
            if (data.id == val.seller__id) {


                return this.setStateForIds({
                    locationId,
                    data,
                    val,
                    dispatch
                })

            } else {
                count++
                if (count === seller.length) {
                    Swal({
                        title: 'Cant find a Seller to this Organisation.',
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'Go Back',
                    })
                        .then(result => {
                            this.props.history.goBack();
                        })
                }
            }
        })
    }

    setStateForIds(objectData) {
        const { locationId, data, val, dispatch } = objectData;
        const userType = localStorage.getItem('usertype')

        return this.setState({
            orgId: locationId,
            sellerId: !userType.includes('seller_admin') ? data.id : this.state.sellerId,
            getImpId: true,
            sellerObj: data,
            orgObj: val,
        }, () => {
            const { orgId, sellerId } = this.state;

            dispatch(creditListActions.getCreditList(sellerId));
            dispatch(creditOrgActions.getOrgCredit(sellerId, orgId))

            dispatch(adminOrgActions.getAdminList(sellerId, orgId))
            dispatch(organisationAction.setIds({
                orgId,
                sellerId
            }))
            dispatch(manageBatchActions.getBatchList({
                orgId,
                sellerId
            }));

            if (userType.includes('super_admin')) {
                dispatch(organisationAction.getDemographicDownload({
                    "organisation_id": parseInt(orgId, 10),
                    "seller_id": parseInt(sellerId, 10)
                }, (demographicData_api) => {
                    const demographicData = demographicData_api.data.response
                    if (demographicData.length) {
                        const keysArrDemographic = Object.keys(demographicData[0]).map(val => {
                            if (val === 'user_details__marital_status') {
                                return 'Marital Status'
                            } else if (val === 'full_name') {
                                return 'Full Name'
                            } else if (val === 'organisation__organisation_name') {
                                return 'Organisation Name'
                            } else if (val === 'date_of_birth') {
                                return 'Date of Birth'
                            } else if (val === 'email') {
                                return 'Email'
                            } else if (val === 'user_details__occupation') {
                                return 'Occupation'
                            } else if (val === 'id') {
                                return 'Id'
                            } else if (val === 'gender') {
                                return 'Gender'
                            } else if (val === 'user_details__city') {
                                return 'City'
                            } else if (val === 'user_details__designation') {
                                return 'Designation'
                            } else if (val === 'user_details__tenure_in_company') {
                                return 'Tenure In Company'
                            } else if (val === 'short_name') {
                                return 'Short Name'
                            } else if (val === 'user_details__work_experience') {
                                return 'Work Experience'
                            } else if (val === 'user_details__alter_email') {
                                return 'Alternate Email'
                            } else if (val === 'user_details__qualification__demographic_name') {
                                return 'Qualification'
                            } else if (val === 'user_details__industry__demographic_name') {
                                return 'Industry'
                            }
                        })
                        let dataDemographicArr = []
                        dataDemographicArr.push(keysArrDemographic)
                        demographicData.map(val => {
                            for (const prop in val) {
                                if (val.hasOwnProperty(prop)) {
                                    if (prop === 'gender') {
                                        if (val[prop] === '1') {
                                            val[prop] = 'Male'
                                        } else if (val[prop] === '2') {
                                            val[prop] = 'Female'
                                        } else if (val[prop] === '3') {
                                            val[prop] = 'Other'
                                        }
                                    } else if (prop === 'user_details__marital_status') {
                                        if (val[prop] === '1') {
                                            val[prop] = 'Single'
                                        } else if (val[prop] === '2') {
                                            val[prop] = 'Married'
                                        } else if (val[prop] === '3') {
                                            val[prop] = 'Divorced'
                                        } else if (val[prop] === '4') {
                                            val[prop] = 'Widow'
                                        }
                                    }
                                }
                            }
                            const arrayData = Object.values(val).map(value => {
                                return value
                            })
                            dataDemographicArr.push(arrayData)
                        })

                        this.setState({
                            downloadCsvData: {
                                keysArrDemographic,
                                dataDemographicArr
                            }
                        }, () => {
                            let buttonDataState = [...this.state.buttonDataState];

                            buttonDataState.push(
                                {
                                    id: 4,
                                    heading: "DOWNLOAD DEMOGRAPHIC DATA",
                                    state: false,
                                    nextLine: true,
                                    toggler: () => downloadCsv(this.state.downloadCsvData.dataDemographicArr, this.state.downloadCsvData.keysArrDemographic, `demogrpahicData.csv`)
                                }
                            )
                            this.setState({
                                buttonDataState
                            })
                        })

                    } else {
                        let buttonDataState = [...this.state.buttonDataState];

                        buttonDataState.push(
                            {
                                id: 4,
                                heading: "DOWNLOAD DEMOGRAPHIC DATA",
                                state: false,
                                nextLine: true,
                                disabled: 'disabled',
                                toggler: () => downloadCsv(['no data'], ['error'], `demogrpahicData.csv`)
                            }
                        )

                        this.setState({
                            buttonDataState
                        })
                    }
                }))
            }
        })
    }

    onDismiss = () => {
        this.setState({
            primaryChangeSuccess: !this.state.primaryChangeSuccess
        })
    }

    togglebatchPermissionModal(showModal) {
        this.setState({
            batchPermissionModal: showModal
        });
    }

    toggleSellCreditsEachModal(showModal, id) {
        const { creditsData } = this.state;
        let availableCredits = 0
        if (showModal === true) {
            for (let i = 0; i < creditsData.length; i++) {
                const element = creditsData[i];
                if (id === element.instrument__id) {
                    availableCredits = element.unsold_credits
                }
            }
        }
        this.setState({
            sellEachCredits: showModal,
            creditTableRowId: id,
            availableCredits
        })
    }

    toggleSellCreditsModal(showModal, id) {
        this.setState({
            sellCredits: showModal,
        }, () => {
            if (showModal === true) {
                this.setState({
                    creditIntrumentId: id
                })
            }
        })
    }
    toggleRevokeCreditsModal(showModal, instrument) {
        const { creditsData } = this.state;

        let availableCredits = 0

        if (showModal === true) {
            for (let i = 0; i < creditsData.length; i++) {
                const element = creditsData[i];
                if (instrument.instrument__id === element.instrument__id) {
                    availableCredits = element.unsold_credits
                }
            }
            this.setState({
                revokeCredits: showModal,
                availableCredits,
                creditTableRowId: instrument.instrument__id
            })
        } else {
            this.setState({
                revokeCredits: showModal,
            }, () => {
                if (showModal === true) {
                    this.setState({
                        creditIntrumentId: instrument.instrument__id,
                    })
                }
            })
        }
    }

    sellCreditsAction(data, row) {

        const { dispatch } = this.props
        let dataObj = {}

        if (Object.keys(data).length > 1) {
            dataObj = {
                seller_id: this.state.sellerId,
                instrument_id: parseInt(data.instrument__instrument_name, 10),
                organisation: this.state.orgId,
                credits: parseInt(data.credits, 10)
            }
        } else {
            dataObj = {
                seller_id: this.state.sellerId,
                instrument_id: this.state.creditTableRowId,
                organisation: this.state.orgId,
                credits: parseInt(data.credits, 10)

            }
        }
        dispatch(organisationAction.sellOrgCreditAction(dataObj))
    }

    revokeCreditsAction(data) {

        const { dispatch } = this.props
        let dataObj = {
            seller_id: this.state.sellerId,
            instrument_id: this.state.creditTableRowId,
            organisation: this.state.orgId,
            credits: parseInt(data.credits, 10)
        }


        dispatch(organisationAction.revokeOrgCreditAction(dataObj))
    }

    toggleRelationModal(showModal) {
        this.setState({
            editRelationState: showModal
        })
    }

    toggleEntireRelationModal(showModal) {
        this.setState({
            editRelationState: showModal
        })
    }

    getValueForRelation(relation) {
        // let value = false;
        for (let j in this.props.organisationList) {
            if (this.props.organisationList[j].id == this.state.orgId) {
                for (let i in this.props.organisationList[j].assessor_group) {


                    if (this.props.organisationList[j].assessor_group[i].assessor_group__assessor_name === relation.assessor_name) {

                        return true
                    }
                }
            }

        }
        return false

    }

    toggleRelationModal(showModal) {

        let addRelation = []
        this.props.relationListResponse.map(
            (relation, i) => {
                addRelation.push(
                    {
                        key: relation.assessor_name,
                        type: 'checkbox',
                        value: this.getValueForRelation(relation),
                        valid: true,
                        elementConfig: {
                            name: relation.assessor_name,
                            label: relation.assessor_name,
                            status: relation.assessor_group_type
                        },
                        validation: {
                            required: false,
                            message: ""
                        }
                    }
                )
            }
        )
        this.setState({
            deleteRelationGroupState: false,
            editRelationState: showModal,
            addRelation: addRelation
        })
    }

    editRelationAction(data) {
        let contId = [];
        const id = this.state.sellerId
        const orgId = this.state.orgId

        for (let i in data.sellerData.relation_list) {
            for (let j in this.props.relationListResponse) {
                if (this.props.relationListResponse[j].assessor_name === data.sellerData.relation_list[i]) {
                    contId.push(this.props.relationListResponse[j].id)
                }
            }
        }
        // const id = this.state.developmentPlanId;

        const fd = {
            'assessor_groups_id': contId
        }


        this.props.dispatch(orgEditRelationAction.editRelation(id, orgId, fd))
    }

    toggleEditRelationResponse(data) {
        this.setState({
            editRelationData: data
        })
    }


    render() {
        const sellerData = this.state.sellerObj;
        const { orgId, sellerId, getImpId, orgObj } = this.state;
        const { orgError, orgLoading, delOrgError, delOrgLoading, loading, admins, adminsError, adminsLoading, creditsLoading, credits, creditsError, organisations, dispatch, countryGetResponse, organisationList, editOrgError, editOrgLoading, editOrgMessage, addAdminMessage, addAdminLoading, addAdminError, batchList, relationListResponse } = this.props;


        admins !== '' &&
            admins.map(val => {
                let attachString = ''
                if (val.batch_permission.length === 0) {
                    val.batch__batch_name = 'No Batches Selected!'
                } else {
                    val.batch_permission.map(value => {
                        if (attachString !== '') {
                            attachString = attachString + ', ' + value.batch__batch_name
                        } else {
                            attachString = value.batch__batch_name
                        }
                    })
                    val.batch__batch_name = attachString
                }
            })







        //go back if organisation is deleted
        if (!delOrgError && !delOrgLoading) {
            this.props.history.goBack();
        }



        //get org id and seller id
        if (!getImpId) {
            this.getSellerOrgId(this.props.sellerGetList)
        }



        formData.map(
            (data, i) => {
                if (Object.keys(sellerData).length !== 0) {
                    data.value = sellerData[data.key];
                    data.valid = true;
                }
            }
        )

        admins !== '' &&
            admins.map(val => {
                if (val.full_name === null) {
                    val.full_name = val.email
                }
            })

        editOrgDetails.map((val, index) => {
            if (val.key === 'country') {
                val.elementConfig.options = countryGetResponse;
            }
            // (this.props.sellerGetList !== '' && Object.keys(sellerData).length !== 0) &&
            this.props.organisationList.map((info, i) => {
                if (info.id == orgId) {
                    if (val.key === 'organisation_name') {
                        val.value = info.organisation_name;
                        val.valid = true
                    } else if (val.key === 'organisation_code') {
                        val.value = info.organisation_code;
                        val.valid = true
                    }
                    else if (val.key === 'address') {
                        val.value = info.address
                        val.valid = true
                    } else if (val.key === 'city') {
                        val.value = info.city
                        val.valid = true
                    } else if (val.key === 'pincode') {
                        val.value = info.pincode
                        val.valid = true
                    } else if (val.key === 'state') {
                        val.value = info.state
                        val.valid = true
                    } else if (val.key === 'country') {
                        val.value = info.country__id
                        val.selected = true
                    }
                }
            })
        })



        addAdminError &&
            (
                dispatch({ type: organisationConstants.DONE_ORG_ADD_ADMIN })
            )

        return (
            <div style={{ minHeight: 'calc(100vh - 100px)' }}>
                <NavBar />
                {
                    this.state.idLoader ?
                        <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                            <LoaderComp color={'black'} />
                        </div>
                        :
                        this.state.hasProperOrgId ?
                            <div className="container my-5" >

                                <div style={{ marginBottom: 20, position: 'relative' }}>
                                    <CommonBreadCrumb
                                        data={[
                                            {
                                                link: '/admin/app/dashboard',
                                                name: 'ADMIN'
                                            }, {
                                                link: '/admin/app/organisation',
                                                name: 'ORGANIZATION'
                                            }, {
                                                link: '',
                                                name: 'ORGANIZATION DETAILS'
                                            }
                                        ]}
                                    />
                                    {
                                        <React.Fragment>
                                            <div className="bg-green rounded-top animation-fade-in" style={{ padding: 10, height: 50 }}>
                                                {
                                                    ((!orgLoading && !orgError)) ?
                                                        organisationList.map(val => {
                                                            if (val.id == this.state.locationId) {

                                                                return <h6 className="text-center text-uppercase text-white mb-0 animation-fade-in" key={1321}> {val.organisation_name} </h6>
                                                            }
                                                        })
                                                        :
                                                        <div className="text-right">
                                                            <LoaderComp color={'white'} />
                                                        </div>
                                                }
                                            </div>


                                            {
                                                ((!orgLoading && !orgError)) &&
                                                <div className="animation-fade-in">
                                                    <SettingsHead
                                                        buttonData={
                                                            this.state.buttonDataState
                                                        }
                                                        externalLinks={
                                                            this.state.externalLinksState
                                                        }
                                                        sellerState={{
                                                            orgId: this.state.orgId,
                                                            sellerId: this.state.sellerId
                                                        }}
                                                        secondColumn={true}
                                                        modal={this.toggleModal.bind(this)}
                                                        deleteAction={sellerAdminActions}
                                                        widthClass="col-md-6"
                                                    />
                                                </div>
                                            }


                                            <div style={{ border: '1px solid #eee', height: '200px' }}>
                                                {
                                                    (!orgError && !orgLoading) &&
                                                    organisationList.map(val => {
                                                        if (val.id == this.state.locationId) {

                                                            return <div className="animation-fade-in">
                                                                <DetailsPanel2
                                                                    id={val.id}
                                                                    heading={"Code: " + val.organisation_code}
                                                                    data={{
                                                                        Seller: val.seller__seller_name,
                                                                        Address: val.address,
                                                                        City: val.city,
                                                                        Country: val.country__country_name,
                                                                        Pincode: val.pincode,
                                                                        State: val.state,
                                                                        orgImg: val.organisation_image
                                                                    }}
                                                                    key={val.id}
                                                                />
                                                            </div>
                                                        }
                                                    })
                                                }
                                                {
                                                    <div style={orgLoading ? { display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center' } : { display: 'none' }}>
                                                        <i className="fas fa-spinner fa-spin text-white" style={{ position: 'absolute', top: 30, left: 3, fontSize: 16 }}></i>
                                                    </div>
                                                }
                                            </div>


                                        </React.Fragment>
                                    }



                                </div>
                                {

                                    <React.Fragment>

                                        <div className="bg-green rounded-top mt-5">
                                            {
                                                (!creditsError && !creditsLoading) ?
                                                    <p className="text-center text-uppercase py-2 text-white mb-0">ORGANISATION CREDITS</p>
                                                    :
                                                    <div className="text-right">
                                                        <LoaderComp color={'white'} />
                                                    </div>
                                            }
                                        </div>
                                        {
                                            (!creditsError && !creditsLoading) &&
                                            localStorage.getItem('usertype').includes('seller_admin') &&
                                            <div className="animation-fade-in">
                                                <SettingsHead
                                                    buttonData={
                                                        [
                                                            {
                                                                id: 1,
                                                                heading: "SELL CREDITS",
                                                                state: this.state.sellCredits,
                                                                toggler: this.toggleSellCreditsModal.bind(this),
                                                            }
                                                        ]
                                                    }
                                                    secondColumn={false}
                                                    widthClass="col-md-6"
                                                />
                                            </div>
                                        }

                                        {
                                            localStorage.getItem('usertype').includes('super_admin') &&
                                            <TableNew
                                                data={this.state.creditsData}
                                                columns={tables.credits}
                                                showSlNo="false"
                                                sellCreditsModal={this.toggleSellCreditsEachModal.bind(this)}
                                                sellCreditsShowModal={this.state.sellEachCredits}
                                                revokeCreditsModal={this.toggleRevokeCreditsModal.bind(this)}
                                                revokeCreditsShowModal={this.state.revokeCredits}
                                                sortBy={(key) => this.sortBy(key, !this.state.sortTypeCredit, 'organisationCreditTable')}
                                                sortType={this.state.sortTypeCredit}
                                            />
                                        }

                                        {
                                            localStorage.getItem('usertype').includes('seller_admin') &&
                                            <TableNew
                                                data={this.state.creditsData}
                                                columns={tables.orgCredits}
                                                showSlNo="false"
                                                sellCreditsModal={this.toggleSellCreditsEachModal.bind(this)}
                                                sellCreditsShowModal={this.state.sellEachCredits}
                                                revokeCreditsModal={this.toggleRevokeCreditsModal.bind(this)}
                                                revokeCreditsShowModal={this.state.revokeCredits}
                                                sortBy={(key) => this.sortBy(key, !this.state.sortTypeCredit, 'organisationCreditTable')}
                                                sortType={this.state.sortTypeCredit}
                                            />
                                        }
                                    </React.Fragment>
                                }

                                {
                                    <div style={{ marginBottom: 10 }}>

                                        <div className="bg-green rounded-top mt-5">
                                            {
                                                (!adminsLoading && !adminsError) ?
                                                    <p className="text-center text-uppercase py-2 text-white mb-0"> ORGANISATION ADMINS </p>
                                                    :
                                                    <div className="text-right animation-fade-in">
                                                        <LoaderComp color={'white'} />
                                                    </div>
                                            }
                                        </div>
                                        {
                                            (!adminsLoading && !adminsError) &&
                                            <div className="animation-fade-in">
                                                <SettingsHead
                                                    buttonData={
                                                        [
                                                            {
                                                                id: 1,
                                                                heading: "ADD A NEW ORGANISATION ADMIN",
                                                                state: this.state.orgAdmin,
                                                                toggler: this.toggleAdminOrgModal.bind(this),
                                                            }
                                                        ]
                                                    }
                                                    secondColumn={false}
                                                    modal={this.toggleModal.bind(this)}
                                                    deleteAction={sellerAdminActions}
                                                    widthClass={'col-md-6'}

                                                />
                                            </div>
                                        }

                                        <CustomTableNew
                                            data={admins}
                                            columns={tables.admins}
                                            showSlNo="false"
                                            checkbox="false"
                                            buttonFunc={this.managePrimaryAdmin.bind(this)}
                                            iconFunc={{
                                                remove: this.delAdmin.bind(this),
                                                delete: this.deleteAdmin.bind(this)
                                            }}
                                            textAlign="center"
                                            sortBy={(key) => this.sortBy(key, !this.state.sortTypeAdmin, 'organisationAdminTable')}
                                            sortType={this.state.sortTypeAdmin}
                                        />

                                        {
                                            this.state.delModal &&
                                            <ModalNew2
                                                heading="DELETE ORGANISATION"
                                                showModal={this.state.delModal}
                                                formData={[]}
                                                selects={[]}
                                                action={this.delOrgAction.bind(this)}
                                                toggleModal={this.toggleDelOrgModal.bind(this)}
                                                viewMessage={[{ text: 'Are you sure you want to delete this organisation?' }]}
                                                triggerType={"Delete"}

                                                disabledButton={true}
                                            />
                                        }

                                        {
                                            this.state.editRelationState &&
                                            <ModalNew
                                                modalName="inlineCheckbox2"
                                                heading="EDIT RELATIONS"
                                                showModal={this.state.editRelationState}
                                                formData={this.state.addRelation}
                                                action={this.editRelationAction.bind(this)}
                                                toggleEditResponse={this.toggleEditRelationResponse.bind(this)}
                                                toggleEntireModal={this.toggleEntireRelationModal.bind(this)}
                                                compartments={{
                                                    key: 'assessor_group_type',
                                                    name: 'assessor_name',
                                                    compartmentData: [
                                                        {
                                                            name: 'Professional',
                                                            value: true
                                                        },
                                                        {
                                                            name: 'Personal',
                                                            value: false
                                                        }
                                                    ]
                                                }}
                                            />
                                        }

                                        {
                                            this.state.orgAdmin &&
                                            <ModalNew2
                                                heading="ADD ORGANISATION ADMIN"
                                                showModal={this.state.orgAdmin}
                                                formData={addAdminOrg}
                                                selects={[]}
                                                action={this.addOrgAdmin.bind(this)}
                                                toggleModal={this.toggleAdminOrgModal.bind(this)}
                                                viewMessage={[{ text: '' }]}
                                                triggerType={"Add Admin"}
                                                noReset={true}
                                            />
                                        }



                                        {
                                            this.state.editOrgModal &&
                                            <ModalNew2
                                                heading="EDIT ORGANISATION"
                                                showModal={this.state.editOrgModal}
                                                formData={editOrgDetails}
                                                selects={['country_name']}
                                                action={this.editOrgAction.bind(this)}
                                                toggleModal={this.toggleEditOrgModal.bind(this)}
                                                viewMessage={[{ text: '' }]}

                                                triggerType={'EDIT'}

                                                selectKey={['id', 'id']}
                                                noReset={true}
                                            />
                                        }
                                        {
                                            this.state.delModal &&
                                            <ModalNew2
                                                heading="DELETE ORGANISATION"
                                                showModal={this.state.delModal}
                                                formData={[]}
                                                selects={[]}
                                                action={this.delOrgAction.bind(this)}
                                                toggleModal={this.toggleDelOrgModal.bind(this)}
                                                viewMessage={[{ text: 'Are you sure you want to delete this organisation?' }]}
                                                triggerType={"Delete"}

                                                disabledButton={true}
                                            />
                                        }
                                        {
                                            this.state.sellCredits &&
                                            <ModalNew2
                                                heading="SELL CREDITS"
                                                showModal={this.state.sellCredits}
                                                formData={[{
                                                    key: 'instrument__instrument_name',
                                                    type: 'select',
                                                    value: '',
                                                    selected: false,
                                                    valid: false,
                                                    regex: "^\\d+$",
                                                    elementConfig: {
                                                        name: 'instrument__instrument_name',
                                                        label: 'Instrument',
                                                        options: [],
                                                        id: 'instrument__id',
                                                        storeKey: ['credits', 'credits'],
                                                        selectText: 'unsold_credits',
                                                        creditsData: this.props.sellerCredits,
                                                        creditsDataId: 'instrument__id'
                                                    },
                                                    validation: {
                                                        required: true,
                                                        message: ""
                                                    },
                                                }, {
                                                    key: '',
                                                    type: 'paraText',
                                                    value: '',
                                                    valid: true,
                                                    regex: '^[0-9]*$',
                                                    elementConfig: {
                                                        name: 'credits',
                                                        label: 'Available credits',
                                                    },
                                                    validation: {
                                                        required: false,
                                                        message: "is required"
                                                    }
                                                }, {
                                                    key: 'credits',
                                                    type: 'text',
                                                    value: '',
                                                    valid: false,
                                                    fieldValid: true,
                                                    // regex: '^[1-9]\d*$',
                                                    elementConfig: {
                                                        name: 'credits',
                                                        label: 'No of Credits',
                                                        placeholder: '999'
                                                    },
                                                    validation: {
                                                        required: true,
                                                        message: "is required"
                                                    },
                                                    fieldValidation: {
                                                        required: /^(?!0+$)[0-9]+$/,
                                                        message: "is invalid"
                                                    }
                                                }]}
                                                creditModal={true}
                                                action={this.sellCreditsAction.bind(this)}
                                                toggleModal={this.toggleSellCreditsModal.bind(this)}
                                                viewMessage={[{ text: '' }]}
                                                triggerType={"SUBMIT"}

                                            />
                                        }
                                        {
                                            this.state.revokeCredits &&
                                            <ModalNew2
                                                heading="REVOKE CREDITS"
                                                showModal={this.state.revokeCredits}
                                                formData={[{
                                                    mainType: 'organisation',
                                                    key: 'credits',
                                                    type: 'number',
                                                    value: '',
                                                    valid: false,
                                                    fieldValid: true,
                                                    // regex: '^[0-9]*$',
                                                    elementConfig: {
                                                        name: 'credits',
                                                        label: 'No of Credits',
                                                        placeholder: '999'
                                                    },
                                                    validation: {
                                                        required: true,
                                                        message: "is required"
                                                    },
                                                    fieldValidation: {
                                                        required: /^(?!0+$)[0-9]+$/,
                                                        message: "is invalid"
                                                    }
                                                }]}
                                                creditModal={true}
                                                rowId={this.state.creditTableRowId}
                                                action={this.revokeCreditsAction.bind(this)}
                                                toggleModal={this.toggleRevokeCreditsModal.bind(this)}
                                                viewMessage={[{ text: '' }]}
                                                triggerType={"SUBMIT"}
                                                cautionText={`Available Credits are ${this.state.availableCredits}`}
                                            />
                                        }

                                        {
                                            this.state.sellEachCredits &&
                                            <ModalNew2
                                                heading="SELL CREDITS"
                                                showModal={this.state.sellEachCredits}
                                                formData={[{
                                                    mainType: 'organisation',
                                                    key: 'credits',
                                                    type: 'number',
                                                    value: '',
                                                    valid: false,
                                                    fieldValid: true,
                                                    // regex: '^[0-9]*$',
                                                    elementConfig: {
                                                        name: 'credits',
                                                        label: 'No of Credits',
                                                        placeholder: '999'
                                                    },
                                                    validation: {
                                                        required: false,
                                                        message: "is required"
                                                    },
                                                    fieldValidation: {
                                                        required: /^(?!0+$)[0-9]+$/,
                                                        message: "is invalid"
                                                    }
                                                }]}
                                                creditModal={true}
                                                rowId={this.state.creditTableRowId}
                                                action={this.sellCreditsAction.bind(this)}
                                                toggleModal={this.toggleSellCreditsEachModal.bind(this)}
                                                viewMessage={[{ text: '' }]}
                                                triggerType={"SUBMIT"}
                                                cautionText={`${this.state.availableCredits} Credits Available!`}
                                            />
                                        }

                                        {
                                            this.state.batchPermissionModal &&
                                            <ModalNew
                                                modalName="inlineOrgAdmin"
                                                heading="ADD BATCH PERMISSION"
                                                showModal={this.state.batchPermissionModal}
                                                formData={this.state.checkBoxArr}
                                                viewMessageAdmin={this.state.checkBoxArr.length !== 0 ? undefined : 'No Batches present for this organistion.'}
                                                action={this.batchPermAdminAction.bind(this)}
                                                toggleEntireModal={this.togglebatchPermissionModal.bind(this)}
                                            />
                                        }


                                    </div>


                                }

                            </div>
                            :
                            <Page404 />
                }

                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {

    //get org list for edit form fill
    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const organisationList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : [];

    //get countries for dropdown on edit organisation
    const countryGetError = state.countries.error;
    const countryGetLoading = state.countries.error;
    const countryGetResponse = (!countryGetError && !countryGetLoading) ? state.countries.countries : '';

    //get credits for table
    const { creditsError, creditsLoading } = state.organisationCredits;
    const credits = (!creditsError && !creditsLoading) ? state.organisationCredits.credits : '';

    //sellerCredits
    const sellerCreditError = state.credits.creditsError
    const sellerCreditLoading = state.credits.creditsLoading
    const sellerCredits = (!sellerCreditError && !sellerCreditLoading) ? state.credits.credits : [];


    //get sellerlist to compare and get org admin data
    const sellerGetError = state.seller.error;
    const sellerGetLoading = state.seller.loading;
    const sellerGetList = (!sellerGetError && !sellerGetLoading) ? state.seller.seller.data.seller_list : '';

    //get admins for organisation
    const { error, loading } = state.organisationAdmins;
    const admins = (!error && !loading && (state.organisationAdmins.admins !== [])) ? state.organisationAdmins.admins : '';

    //delete org status
    const { delOrgError, delOrgLoading, delOrgMessage } = state.deleteOrgState;

    //add admin
    const { addAdminMessage, addAdminLoading, addAdminError } = state.AddOrganisationAdmins

    const { deleteAdminMessage, deleteAdminLoading, deleteAdminError, payload } = state.deleteOrganisationAdmins;


    //
    const { editOrgError, editOrgLoading, editOrgMessage } = state.editOrgState

    //batch list
    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : '';


    //seller and org id
    const { setSellerAndOrgId } = state

    // Relation list
    const { RelationListLoading } = state.relationList;
    const relationListResponse = (!RelationListLoading) ? state.relationList.data.data.results : '';
    const relationListResponseCode = (!RelationListLoading) ? state.relationList.data.status : '';


    return {
        state,
        orgLoading,
        orgError,
        organisationList,
        admins,
        adminsError: error,
        adminsLoading: loading,
        loading,
        creditsLoading,
        creditsError,
        credits,
        countryGetLoading,
        countryGetResponse,
        sellerGetList,
        delOrgLoading,
        delOrgError,
        delOrgMessage,
        addAdminError,
        addAdminLoading,
        addAdminMessage,
        editOrgLoading,
        editOrgError,
        editOrgMessage,
        setSellerAndOrgId,
        batch_list_error,
        batchList,
        batch_list_loading,
     

        sellerCredits,


        relationListResponse,
        relationListResponseCode,
        deleteAdminMessage,
        deleteAdminLoading,
        deleteAdminError,
        payload,


    };
}

export default connect(mapStateToProps)(OrgDetails);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/Details/index.js